/**
 * @generated SignedSource<<38114465fba396ca97d08499159708e1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "styleId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "styleId",
        "variableName": "styleId"
      }
    ],
    "concreteType": "BasicMutationResponse",
    "kind": "LinkedField",
    "name": "deleteStyle",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteStyleMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteStyleMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d9f659a3b7ad7b35978b45445ddf2e98",
    "id": null,
    "metadata": {},
    "name": "DeleteStyleMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteStyleMutation(\n  $styleId: ID!\n) {\n  deleteStyle(styleId: $styleId) {\n    ok\n    error\n  }\n}\n"
  }
};
})();

node.hash = "7c2f246873753a2fbe29e8b27af6effb";

export default node;
